import { WappMode } from '@weblite-wapps/protocol'
import { WapprunnerCreate } from 'weblite-web-wapprunner'
import { VisibilityHandler } from '$scenes/components/visibility-handler'
import { useCurrentOverlayWappMeta } from './react-hooks'

export function WappOverlayPanel({ zIndex }: { zIndex: number }) {
  const currentWappMeta = useCurrentOverlayWappMeta()
  if (!currentWappMeta || !('wappId' in currentWappMeta)) return null

  const { wappSessionId, wappId, wisId, input, parentWapp } = currentWappMeta
  return (
    <VisibilityHandler
      zIndex={zIndex}
      style={{ position: 'fixed', maxWidth: '1680px', margin: 'auto' }}
    >
      <WapprunnerCreate
        key={wappSessionId}
        wappSessionId={wappSessionId}
        wappId={wappId}
        wisId={wisId}
        mode={WappMode.OVERLAY}
        input={input}
        parentWapp={parentWapp}
      />
    </VisibilityHandler>
  )
}
